<template>
    <div>
        <el-form :inline="true">
            <el-form-item>
                <el-button type="primary" @click="addUpdateCarouselMapButton(0)" v-if="hasAuth('sys:share:save')">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table
                ref="multipleTable"
                :data="shareList"
                tooltip-effect="dark"
                style="width: 100%"
                border
                stripe
                @selection-change="handleSelectionChange">

            <el-table-column
                    type="selection"
                    align="center"
                    fixed="left"
                    width="55">
            </el-table-column>
            <el-table-column
                    prop="title"
                    label="标题"
                    align="center"
                    width="500">
            </el-table-column>
            <el-table-column prop="picUrl" width="100" align="center" label="图片">
                <template slot-scope="scope">
                    <el-image style="width: 50px; height: 50px" :src="scope.row.picUrl" fit="scale-down"></el-image>
                </template>
            </el-table-column>
            <el-table-column
                    prop="type"
                    align="center"
                    label="类型"
                    width="120">
                <template slot-scope="scope">
                    <el-tag size="small" v-if="scope.row.type == 1" type="info">资讯</el-tag>
                    <el-tag size="small" v-else-if="scope.row.type == 2" type="success">社区</el-tag>
                    <el-tag size="small" v-else-if="scope.row.type == 3" type="success">商城</el-tag>
                    <el-tag size="small" v-else-if="scope.row.type == 4" type="success">我的</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                    prop="createTime"
                    align="center"
                    width="200"
                    label="创建时间">
            </el-table-column>
            <el-table-column
                    prop="updateTime"
                    align="center"
                    width="200"
                    label="更新时间">
            </el-table-column>
            <el-table-column
                    prop="icon"
                    width="250"
                    align="center"
                    label="操作">
                <template slot-scope="scope">
                    <el-button type="primary" plain @click="addUpdateCarouselMapButton(scope.row.id)"  v-if="hasAuth('sys:share:update')">编辑</el-button>
                    <template  v-if="hasAuth('sys:share:delete')">
                        <el-popconfirm title="这是一段内容确定删除吗？" @confirm="delHandle(scope.row.id)">
                            <el-button type="danger" plain slot="reference">删除</el-button>
                        </el-popconfirm>
                    </template>

                </template>
            </el-table-column>
        </el-table>
        <AddUpdateShare ref="addUpdateShare" v-if="addUpdateSharevisible" @refreshDataList="getShareList"></AddUpdateShare>
    </div>
</template>
<script>
    import AddUpdateShare from "./AddUpdateShare";
    export default {
        name: "Share",
        components:{
            AddUpdateShare
        },
        data() {
            return {
                shareList: [],
                delBtlStatu: true,
                multipleSelection:[],
                addUpdateSharevisible: false,
            }
        },
        created() {
            this.getShareList()
        },
        methods:{
            getShareList() {
                this.$axios.post("/admin/share/getShareList").then(res => {
                    this.shareList = res.data;
                })
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                this.delBtlStatu = val.length == 0
            },
            addUpdateCarouselMapButton(id){
                this.addUpdateSharevisible=true
                this.$nextTick(()=>{
                    this.$refs.addUpdateShare.init(id);
                })
            },
            delHandle(id) {
                this.$axios.post("/admin/share/deleteShare", {id:id}).then(res => {
                    this.$message({
                        showClose: true,
                        message: '恭喜你，操作成功',
                        type: 'success',
                        onClose:() => {
                            this.getShareList()
                        }
                    });
                })
            },
        }
    }
</script>

<style scoped>
    .el-button{
        padding: 0 10px;
        height: 35px;
        line-height:35px;
        font-size:15px;
        margin-right: 10px;
    }
</style>
